import { twMerge } from 'tailwind-merge';
import { MenuItem } from '@/features/layout/types/layout.types';
import React from 'react';
import { IoChevronForward } from 'react-icons/io5';

const NavItemMobile = ({ title, Icon, selected, onClick, comingSoon }: MenuItem) => {
  const textColor = selected ? 'text-ph-gray-white' : comingSoon ? 'text-ph-gray-evening' : 'text-ph-white-50';

  return (
    <div onClick={onClick} className="flex w-full items-center justify-between">
      <div
        className={twMerge(
          !comingSoon ? 'cursor-pointer' : 'cursor-default',
          'flex items-center justify-between gap-2',
        )}
      >
        <Icon size={24} className={twMerge(!comingSoon ? 'text-ph-primary-violet' : 'text-ph-gray-evening')} />
        <div className="flex flex-col">
          <span className={twMerge('text-base font-semibold', textColor)}>{title}</span>
          {comingSoon && <legend className="text-xxs text-sm font-bold text-ph-orange-burned">COMING SOON</legend>}
        </div>
      </div>
      {!comingSoon && <IoChevronForward className={textColor} />}
    </div>
  );
};

export default NavItemMobile;
